module.exports = __webpack_public_path__ + "img/centennial - testimonial video - poster 1.c95dd5c8.jpg";